export const languageComponents = [
    {lang: "en", name: 'Eng'},
    {lang: "ru", name: 'Rus'},
    {lang: "ua", name: 'Ukr'},
];

export const availableLanguages = languageComponents.map(l => l.lang);

